import React, { ReactNode } from "react";
import styled from "styled-components";
import ReactCollapsy from "react-collapsy";
import "react-collapsy/lib/index.css";

import {
  assets,
  colors,
  MOBILE_BREAKPOINT,
  DEFAULT_FONT,
} from "@util/constants";

interface Props {
  title: string;
  children: ReactNode;
  padding?: string;
  margin?: string;
  normal?: boolean;
  onWork?: () => void;
  noBorder?: boolean;
  classNames?: string;
}

const StyledAccordion = styled(ReactCollapsy) <{
  isLast?: boolean;
  padding?: string;
  margin?: string;
  normal?: boolean;
  noBorder?: boolean;
}>`
  border: none;
  border-top: 1px solid var(--theme-primary-color);
  border-top-left-radius: unset !important;
  border-top-right-radius: unset !important;
  ${({ isLast }) => isLast && `border-top: none`};
  margin: ${props => (props.margin ? `${props.margin};` : "0 0 30px 0")};
  ${({ noBorder }) => (noBorder ? `border: none !important;` : ``)};

  .Accordion__header {
    background: transparent;
    color: var(--theme-primary-color);
    padding: ${props => (props.padding ? `${props.padding};` : "20px 0")};
    cursor: pointer;
    width: 80%;
    border-radius: 0;
    font-weight: ${props => (props.normal ? "normal" : "bold")} !important;
    line-height: 24px;
    font-family: ${DEFAULT_FONT};
    @media only screen and (max-width: ${MOBILE_BREAKPOINT}px) {
      line-height: 17px;
      font-size: 17px;
    }
    &::after {
      filter: invert(1);
    }
  }

  .Accordion__body {
    padding-left: 0px;
  }
  .Accordion__header--collapsed {
    font-weight: ${props => (props.normal ? "normal" : "bold")} !important;
    height: max-content;
  }
`;

export default function Accordion({
  children,
  title,
  padding,
  margin,
  normal,
  onWork,
  noBorder,
  classNames,
}: Props) {
  return (
    <StyledAccordion
      title={title}
      padding={padding}
      margin={margin}
      normal={normal}
      onWork={onWork}
      noBorder={noBorder}
      className={classNames ?? ""}
    >
      {children}
    </StyledAccordion>
  );
}
